import React from 'react';

import StructuredData from '@swf/components/StructuredData/StructuredData';

import type { SportsEventProps } from './hooks/useFormatSportsEvent';
import { useFormatSportsEvent } from './hooks/useFormatSportsEvent';

const EventStructuredData: React.FC<SportsEventProps> = (props) => {
  const structuredData = useFormatSportsEvent(props);

  if (!structuredData) {
    return null;
  }

  return <StructuredData data={structuredData} />;
};

export default EventStructuredData;
